import { DocumentFiles } from "domain/entities/document-files";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface DocumentFilesState {
  documentfile: DocumentFiles | null;
  setDocumentFile: (newDocumentFile: DocumentFiles | null) => void;
}

export const useDocumentFilesStore = create<DocumentFilesState>()(
  devtools(
    (set) => ({
      documentfile: null,
      setDocumentFile: (newDocumentFile) =>
        set(() => ({
          documentfile: newDocumentFile,
        })),
    }),
    { name: "DocumentFilesStore" }
  )
);